export default (templateData) => ({
  currency: templateData?.currency,
  accountNumber: templateData?.accountNumber?.trim() || null,
  sortCode: templateData?.sortCode?.trim().replace(/-/g, '') || null,
  network: templateData?.network || null
});
